import type { FunctionComponent } from 'react';

import { Field, Label } from '@kanda-libs/ks-component-ts';
import { Text } from '@kanda-libs/ks-design-library';

import { CLASS_NAMES } from './constants';
import useTerms from './useTerms';

import { CheckoutFinanceRate } from '../constants';

export interface ChooseTermProps {
  rates: CheckoutFinanceRate[];
  isLoading: boolean;
  bnpl?: boolean;
}

const ChooseTerm: FunctionComponent<ChooseTermProps> = function ({
  rates,
  isLoading,
  bnpl = false,
}) {
  const { options, showBNPLNotice, selectedRate } = useTerms(rates, bnpl);

  return (
    <>
      <Label label="Choose term" />
      <Field.Validator
        validation={{
          required: { value: true, message: 'Term is required.' },
        }}
      >
        <Field.RadioSelect
          name="duration"
          inline
          wrap
          wrapBorder={false}
          variant="streamline"
          options={options}
          isLoading={isLoading}
        />
      </Field.Validator>
      {showBNPLNotice && (
        <Text
          text={`Enjoy ${
            selectedRate?.deferredDuration
          } number of months before repayment starts where you can choose to pay nothing, some, or all of the balance with no interest (£29 admin fee applies); the remaining balance is then repaid over ${
            selectedRate?.duration
          } months at ${
            parseInt(selectedRate?.interest || '0', 10) / 100
          }% APR.`}
          className={CLASS_NAMES.BNPLNotice}
        />
      )}
    </>
  );
};

export default ChooseTerm;
